import { ShowErrorFunc, ShowErrorProps } from 'mui-rff';
import { setIn } from 'final-form';
import * as yup from 'yup';
import { PASSWORD_REGEX, PHONE_LENGTH } from './constants';
import { mapYupObjectError, objectMap } from './helpers';

export const showErrorOnChange: ShowErrorFunc = ({
  meta: { submitError, dirtySinceLastSubmit, error, touched },
}: ShowErrorProps) => !!(((submitError && !dirtySinceLastSubmit) || error) && touched);

export const neverShowError = () => false;

export const validationCallback = <T>(schema: yup.SchemaOf<T>) => (values: T) => {
  try {
    schema.validateSync(values, { abortEarly: false });
  } catch (e: any) {
    // const valErrs = mapYupObjectError<T>(e);
    // return objectMap(valErrs, (v: string[]) => v[0]);
    const errors = e.inner.reduce((formError: any, innerError: { path: string; message: unknown; }) =>
      setIn(formError, innerError.path, innerError.message), {});

    return errors;
  }
  return undefined;
};

export const validationCallbackOld = <T>(schema: yup.SchemaOf<T>) => (values: T) => {
  try {
    schema.validateSync(values, { abortEarly: false });
  } catch (e) {
    const valErrs = mapYupObjectError<T>(e);
    return objectMap(valErrs, (v: string[]) => v[0]);
  }
  return undefined;
};


export const requiredOnly = (name: string) => (
  yup.string().required(`${name} is required`)
);

export const numbersOnly = (name: string) => (
  yup.string()
    .matches(/^\d+$/, 'Not a number')
    .required(`${name} is required`)
);

export const validateAccountFAB = (name = 'Account number') => (
  yup.string().label(name)
    .min(13, '13 digits required')
    .matches(/^\d+$/, 'Not a number')
    .required(`${name} is required`)
);

export const validateAccount = (name = 'Account number') => (
  yup.string().label(name)
    .matches(/^\d+$/, 'Not a number')
    .required(`${name} is required`)
);

export const notRequiredValidateAccount = (name = 'Account number') => (
  yup.string().label(name)
    .test('len', '13 digits required', (val) => val?.toString().length === 13 || val?.toString().length === 0)
);

export const validateAmount = (name = 'Amount') => (
  yup.string().label(name)
    .notOneOf(['0', '0.00'], `${name} is required`)
    .required(`${name} is required`)
);

export const validatePhone = (name = 'Phone number', limit = PHONE_LENGTH) => (
  yup.string().label(name)
    .min(limit, `${limit} digits required`)
    .required(`${name} is required`)
);

export const validateDate = (name = 'Date of birth') => (
  yup.date().label(name)
    .typeError(`${name} is not verified`)
    .required(`${name} is required`)
);

export const validatePin = (name = 'PIN') => (
  yup.string().label(name)
    .length(4)
    .matches(/^\d+$/, `${name} should contain only numbers`)
    .required(`${name} is required`)
);

export const validateOtp = (name = 'OTP') => (
  yup.string().label(name)
    .length(5)
    .matches(/^\d+$/, `${name} should contain only numbers`)
    .required(`${name} is required`)
);

export const validateConfirmPin = (
  fieldName: string, name = 'Confirm PIN', message = 'PINs do not match!',
) => (
  yup.string().label(name)
    .oneOf([yup.ref(fieldName)], message)
    .required()
);

export const validatePassword = (name = 'Password') => (
  yup.string().label(name)
    .matches(PASSWORD_REGEX, 'Password must contain at least one uppercase, special character and a number')
    .required()
);

export const validateConfirmPassword = (
  fieldName: string, name = 'Confirm Password', message = 'Passwords do not match!',
) => (
  yup.string().label(name)
    .oneOf([yup.ref(fieldName)], message)
    .required()
);

export const validateEmail = (name = 'Email') => (
  yup.string().label(name)
    .email()
    .required()
);

export const notRequiredValidateEmail = (name = 'Email') => (
  yup.string().label(name)
    .email()
);

export const validateUsername = (name = 'Username') => (
  yup.string().label(name)
    .min(6, 'must be 6 characters minimum')
    .max(10, 'must be 10 characters maximum')
    .matches(/(?=.*\d)(?=.*[a-zA-Z]).*/g, `${name} must be alphanumeric`)
    .required(`${name} is required`)
);
